import { render, staticRenderFns } from "./pdfDetail.vue?vue&type=template&id=3fc0d000&scoped=true&"
import script from "./pdfDetail.vue?vue&type=script&lang=js&"
export * from "./pdfDetail.vue?vue&type=script&lang=js&"
import style0 from "./pdfDetail.vue?vue&type=style&index=0&id=3fc0d000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0d000",
  null
  
)

export default component.exports